import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { FlexColumn } from '../../atoms/layout/Flex'
import Dialog from '../../atoms/feedback/Dialog'
import Label from '../../atoms/display/Label'
import Button from '../../atoms/inputs/Button'
import { useAgreementRejectDialog } from '../../../hooks/useDialog'
import TextField from '../../atoms/inputs/TextField'
import FormItem from '../../molecules/inputs/FormItem'
import { AgreementActions } from '../../../store/agreement'

export default function AgreementRejectDialog() {
  const { state, close } = useAgreementRejectDialog()
  const [reason, setReason] = useState<string>('')
  const dispatch = useDispatch()

  const handleReject = useCallback(() => {
    if (!state?.agreementId || reason.length === 0) {
      return
    }
    dispatch(AgreementActions.rejectAgreement({ agreementId: state.agreementId, reason }))
  }, [dispatch, reason, state])

  return (
    <Dialog
      open={state !== undefined}
      title="契約の却下"
      width="xs"
      actions={
        <Button color="caution" disabled={!reason} onClick={handleReject}>
          却下する
        </Button>
      }
      onClose={close}
    >
      <FlexColumn maxHeight="60vh">
        <Label text="この契約を却下しますか？" />
        <FormItem label="却下理由">
          <TextField value={reason} onChange={(value) => setReason(value ?? '')} multiline rows={5} />
        </FormItem>
      </FlexColumn>
    </Dialog>
  )
}
